import { AssetMainType } from '../models/asset';
import type { AssetType as AnalyticsAssetType } from './events';

/** AssetListType keys from AssetHandleSidebar — group names shown in the UI. */
export type AssetListGroupName =
  | 'CDB,CRA,CRI,LC,LCA,LCI,LF'
  | 'Poupança'
  | 'Tesouro Direto'
  | 'Conta Corrente'
  | 'Personalizado'
  | 'Imóveis'
  | 'Veículo'
  | 'Debênture'
  | 'Moedas'
  | 'Cripto'
  | 'Fundos de Investimento'
  | 'Fundos de Inv. / Prev.'
  | 'Ações';

const ASSET_LIST_GROUP_TO_ANALYTICS: Record<string, AnalyticsAssetType> = {
  'CDB,CRA,CRI,LC,LCA,LCI,LF': 'private_bonds',
  'Poupança': 'saving_account',
  'Tesouro Direto': 'treasure_bounds',
  'Conta Corrente': 'checking_account',
  Personalizado: 'customized',
  Imóveis: 'property',
  Veículo: 'vehicle',
  Debênture: 'debenture',
  Moedas: 'currency',
  Cripto: 'cripto',
  'Fundos de Investimento': 'fund',
  'Fundos de Inv. / Prev.': 'fund',
  Ações: 'stock',
};

const ASSET_MAIN_TYPE_TO_ANALYTICS: Record<AssetMainType, AnalyticsAssetType> = {
  [AssetMainType.PrivateBound]: 'private_bonds',
  [AssetMainType.SavingAccount]: 'saving_account',
  [AssetMainType.TreasureBound]: 'treasure_bounds',
  [AssetMainType.CheckingAccount]: 'checking_account',
  [AssetMainType.Customized]: 'customized',
  [AssetMainType.Property]: 'property',
  [AssetMainType.Vehicle]: 'vehicle',
  [AssetMainType.Debenture]: 'debenture',
  [AssetMainType.Currency]: 'currency',
  [AssetMainType.Cripto]: 'cripto',
  [AssetMainType.InvestimentFunds]: 'fund',
  [AssetMainType.Stock]: 'stock',
};

export function assetListGroupToAnalyticsType(
  groupName: string,
): AnalyticsAssetType | undefined {
  if (groupName.startsWith("Fundos")) {
    return "fund";
  }
  return ASSET_LIST_GROUP_TO_ANALYTICS[groupName];
}

export function assetMainTypeToAnalyticsType(
  type: AssetMainType,
): AnalyticsAssetType {
  return ASSET_MAIN_TYPE_TO_ANALYTICS[type];
}

/** Sanitizes API paths for error_request_failed — strips user ids. */
export function sanitizeEndpoint(path: string): string {
  return path
    .replace(/\/user\/[a-f0-9]{24}/gi, '/user/:id')
    .replace(/\/asset\/[a-f0-9]{24}/gi, '/asset/:id')
    .replace(/\/property\/user\/[a-f0-9]{24}/gi, '/property/user/:id')
    .replace(/\/goal\/[a-f0-9]{24}/gi, '/goal/:id');
}
